import { useMutation } from "@apollo/client";
import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";

import { CREATE_INTENT_PROJECT } from "./gql";

const useCreateIntentProject = () => {
  const { onError } = useTypedContext(FlashContext);

  const [createMutation, { loading, error }] = useMutation(CREATE_INTENT_PROJECT);

  const createIntentProject = useCallback(
    async (input: { name: string; description?: string; space: string }) => {
      try {
        const result = await createMutation({
          variables: {
            name: input.name,
            description: input.description || null,
            space: input.space,
          },
        });

        return result.data!.intentProjectCreate;
      } catch (error) {
        onError(error);
        return undefined;
      }
    },
    [createMutation, onError]
  );

  return {
    createIntentProject,
    loading,
    error,
  };
};

export default useCreateIntentProject;
